import { ApiEndpoint } from "@/app/apiEndpoint";
import axios from "@/app/http/axios";
import { MainTopic } from "@/interface/MainTopic.interface";

export default class AdminTopicService {
  constructor() {}

  async getAllMainTopics() {
    const path = ApiEndpoint.AdminComplaintTopic.GET_ALL_MAIN;
    try {
      const response = await axios.get<MainTopic[]>(`${path}`, {
        headers: { "Content-Type": "application/json" },
      });
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async getMainsWithConditions(filter: any) {
    const path = ApiEndpoint.AdminComplaintTopic.SEARCH;
    try {
      const response = await axios.post<MainTopic[]>(`${path}`, filter);
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async createMain(value: any) {
    const path = ApiEndpoint.AdminComplaintTopic.CREATE_MAIN;
    try {
      const response = await axios.post(`${path}`, value);
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async updateMain(mainId: number, value: any) {
    const path = ApiEndpoint.AdminComplaintTopic.UPDATE_MAIN;
    try {
      const response = await axios.patch(
        `${path.replace("{id}", mainId.toString())}`,
        value
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async updateStatusMain(mainId: number, value: any) {
    const path = ApiEndpoint.AdminComplaintTopic.UPDATE_STATUS_MAIN;
    try {
      const response = await axios.patch(
        `${path.replace("{id}", mainId.toString())}`,
        value
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async orderMain(value: any[]) {
    const path = ApiEndpoint.AdminComplaintTopic.ORDER_MAIN;
    try {
      const response = await axios.put(`${path}`, value);
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async createSub(mainId: number, value: any) {
    const path = ApiEndpoint.AdminComplaintTopic.CREATE_SUB;
    try {
      const response = await axios.post(
        `${path.replace("{mainId}", mainId.toString())}`,
        value
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async updateSub(subId: number, value: any) {
    const path = ApiEndpoint.AdminComplaintTopic.UPDATE_SUB;
    try {
      const response = await axios.patch(
        `${path.replace("{id}", subId.toString())}`,
        value
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async updateStatusSub(subId: number, value: any) {
    const path = ApiEndpoint.AdminComplaintTopic.UPDATE_STATUS_SUB;
    try {
      const response = await axios.patch(
        `${path.replace("{id}", subId.toString())}`,
        value
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async orderSub(value: any[]) {
    const path = ApiEndpoint.AdminComplaintTopic.ORDER_SUB;
    try {
      const response = await axios.put(`${path}`, value);
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async deleteSub(subId: number) {
    const path = ApiEndpoint.AdminComplaintTopic.UPDATE_SUB;
    try {
      const response = await axios.delete(
        `${path.replace("{id}", subId.toString())}`
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }
}
